<script>
import PagePushCard from '@phoenix/mixins/components/molecules/PagePushCard';
import PictureLazy from '@maison/components/common/PictureLazy';
import { PhxIcon } from '@phx-styleguides/jlc';

export default {
  components: {
    PictureLazy,
    PhxIcon,
  },

  mixins: [PagePushCard],

  props: {
    preTitle: {
      type: String,
      default: '',
    },
    dataTracking: {
      type: Object,
      default: null,
    },
  },
};
</script>

<template>
  <div class="card">
    <div class="card__media">
      <picture-lazy v-bind="rokkaImg" />
    </div>

    <div class="card__details">
      <div v-if="preTitle" class="card__pretitle h6">{{ preTitle }}</div>

      <div class="card__title h5">{{ title }}</div>

      <div v-if="description" class="card__body">{{ description }}</div>

      <a
        :href="link"
        class="btn btn--link btn--icon card__button expand-target"
        :data-tracking="dataTracking ? JSON.stringify(dataTracking) : null"
      >
        <span class="btn__text">{{ $t('Search.article.discoverTheStory') }}</span>
        <span class="btn__icon">
          <phx-icon icon="chevron-10" bidirectional />
        </span>
      </a>
    </div>
  </div>
</template>
